import { render, staticRenderFns } from "./AccessItemEdit.vue?vue&type=template&id=11796e6e&scoped=true&"
import script from "./AccessItemEdit.vue?vue&type=script&lang=js&"
export * from "./AccessItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./AccessItemEdit.vue?vue&type=style&index=0&id=11796e6e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11796e6e",
  null
  
)

export default component.exports